import * as types from 'model/actionTypes'
import { DictT, ProjectT } from 'model/types'

export function receiveProjects (projects: DictT<ProjectT>) {
  return {
    type: types.RECEIVE_PROJECTS,
    projects
  }
}
